import { NO_VALUE } from './constants'
import { isArray, isNumber, floor, isNil } from 'lodash'

function getParamsOfProperty(obj = {}) {
  const { propertyInfo: { params = [] } = {} } = obj
  return params
}

function getUnit(params) {
  return (params[0] && params[0].unit) || null
}

function returnValueWithUnit(value, unit) {
  return value!==undefined ? `${value} ${unit || ''}` : NO_VALUE
}

export const getVoltage = (obj = {}) => {
  const params = getParamsOfProperty(obj)
  const unit = getUnit(params)
  let value = obj.propertyValue
  if (isNumber(value)) value = value.toFixed(2)
  return returnValueWithUnit(value, unit)
}

export const getCurrent = (obj = {}) => {
  // const unit = getUnit(getParamsOfProperty(obj))
  let value = obj.propertyValue
  if (isNumber(value)) value = (value*1000)
  return returnValueWithUnit(value, 'mA')
}

export const getSignalType = (obj = {}) => {
  const params = getParamsOfProperty(obj)
  const value = obj.propertyValue
  const { range = [] } = params[0] || {}
  const item = range.filter(item => item.value === value)[0]
  return item && item.name
}

export const getBlinkingType = (obj = {}) => {
  const params = getParamsOfProperty(obj)
  const value = obj.propertyValue
  const { range = [] } = params[0] || {}
  const item = range.filter(item => item.value === value)[0]
  return item && item.name
}

export const getSignalCode = (obj = {}) => {
  return obj.propertyValue || NO_VALUE
}

export const getPhoneNumber = (obj = {}) => {
  return obj.propertyValue || NO_VALUE
}

export const getRiverBranch = (obj = {}) => {
  return obj.propertyValue || NO_VALUE
}

export const getValueProperties = (obj = {}) => {
  return obj.propertyValue || NO_VALUE
}

export const getLocationSetup = (obj = {}) => {
  const { propertyValue } = obj
  return isArray(propertyValue) && propertyValue.length === 2
    ? {
        value: propertyValue,
        display: `${propertyValue[1]}\n${propertyValue[0]}`
      }
    : NO_VALUE
}

export const getLocation = (obj = {}) => {
  if (isNil(obj)) return NO_VALUE
  const { coordinates } = obj
  return isArray(coordinates) && coordinates.length === 2
    ? {
        value: coordinates,
        display: `${floor(coordinates[1], 5)}\n${floor(coordinates[0], 5)}`
      }
    : NO_VALUE
}

export const getLocationSetupRadius = (obj = {}) => {
  return obj.propertyValue || NO_VALUE
}

export const getLightPower = (obj = {}) => {
  const params = getParamsOfProperty(obj)
  const value = obj.propertyValue
  const { range = [] } = params[0] || {}
  const item = range.filter(item => item.value === value)[0]
  return item && item.name
}

export const getStatus = (obj = {}) => {
  const params = getParamsOfProperty(obj)
  const value = obj.propertyValue
  const { range = [] } = params[0] || {}
  const item = range.filter(item => item.value === value)[0]
  return item || NO_VALUE
}
